//import { defineCustomElement } from 'vue'


import WeatherMapAi from './components/WeatherMapAi.vue';
import WeatherCherryPicker from './components/WeatherCherryPicker.vue';
import WeatherExceptionTracker from './components/weatherexceptions/WeatherExceptionTracker.vue';
import ModelComparison from './components/ModelComparison.vue';
// Import our custom CSS
import './scss/styles.scss'
import './wxwidgets/wxwidgets.scss'



//import { createApp } from 'vue'

//export { createApp, WeatherSummary2Component };

//createApp(WeatherSummary2Component).mount('#app')


let VcComponentLoader = (function(){
    console.log("Starting VcDevComponentLoader..." );
    const COMPONENTS={
       
        'WeatherMapAi':WeatherMapAi,
        "WeatherCherryPicker":WeatherCherryPicker,
        'WeatherExceptionTracker': WeatherExceptionTracker,
        'ModelComparison': ModelComparison,
        
    };

    window.VcAvailableComponents=(window.VcAvailableComponents && { ...window.VcAvailableComponents, ...COMPONENTS }) || COMPONENTS;
    /*
    let isReady=false;

    window.addEventListener("load",function(event) {
        isReady=true;

        attachComponents();
        
    },false);
   
    function attachComponents() {
        if (!window.VcComponents) {
            console.log("No VcComponents found..." );
            return;
        }

        window.VcComponents.forEach(item => {
            if (!COMPONENTS[item.component]) {
                console.log("Component not found..." +item.component);
                return;
            }
            console.log("Component being mounted..." +item.component);
            createApp(COMPONENTS[item.component]).mount(item.selector)
        });
    }*/
})();



